'use client'

import { Button, toast, useDocumentInfo } from '@payloadcms/ui'
import React, { useState } from 'react'

const RecalculateProgressButton: React.FC = () => {
  const { id } = useDocumentInfo()
  const [result, setResult] = useState<{
    success: boolean
    message: string
    data?: {
      syncedCount: number
      errorCount: number
      errors?: Array<{ progressId: number; error: string }>
    }
  } | null>(null)

  const handleRecalculate = async () => {
    if (!id) {
      toast.error('No skill tree ID available')
      return
    }

    setResult(null)

    const recalculatePromise = fetch(`/api/skill-trees/${id}/recalculate-progress`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(async (response) => {
      const data = await response.json()

      if (!response.ok) {
        throw new Error(data.error || data.details || 'Failed to recalculate progress')
      }

      return data
    })

    toast.promise(recalculatePromise, {
      loading: 'Recalculating student progress...',
      success: (data) => {
        setResult(data)
        return data.message || 'Progress recalculated successfully'
      },
      error: (err) => {
        const errorMessage = err instanceof Error ? err.message : 'An unknown error occurred'
        return `Failed to recalculate progress: ${errorMessage}`
      },
    })
  }

  return (
    <div className="">
      <div className="mb-4">
        <h3 className="text-xl font-semibold mb-2">Recalculate Student Progress</h3>
        <p className="text-base text-[var(--theme-elevation-600)]">
          Manually trigger recalculation of all student progress for this skill tree.
          <br />
          This syncs progress with the current skill tree structure, handling new nodes, removed
          nodes, and updated dependencies.
        </p>
        <Button onClick={handleRecalculate} buttonStyle="primary" size="large">
          Recalculate Progress
        </Button>
      </div>
    </div>
  )
}

export default RecalculateProgressButton
